import React, { Component } from "react";

export default class NotFound extends Component {
  render() {
    return (
      <div className="page-margin-top">
        <div style={{ color: "white", fontSize: "50px" }}>
          404 - Page Not Found
        </div>
      </div>
    );
  }
}
